import { useWhitelabelContext } from 'context/whitelabel.context';
import { useRouter } from 'next/router';
import React from 'react';
import { getClassNameByLang } from 'utils/getClassByLang';
import { SubHeading } from './Typography/General';
import { isMobile } from 'react-device-detect';

export default function Breadcrumb({ data, variant = 'padding', dir = 'ltr', language = '' }) {
  const router = useRouter();
  // const { data: dataProps, variant = 'padding', dir = 'ltr', language = '' } = props;

  const wrapper = 'breadcrumb-wrapper';
  const customWrapper = variant === 'padding' ? wrapper : wrapper + '-2';
  return (
    <SubHeading tag="div" variety={isMobile ? 3 : 4} className={customWrapper}>
      {data.map((item, index) => {
        return (
          <React.Fragment key={index}>
            <span
              dir={dir}
              className={`${
                item.active ? 'breadcrumb-text breadcrumb-text-active' : 'breadcrumb-text'
              } ${getClassNameByLang(language)}`}
              style={{ textTransform: 'capitalize' }}
              onClick={() => {
                if (item.url) router.push(item.url);
              }}
            >
              {item.title}
            </span>
            {index !== data.length - 1 && <img className="breadcrumb-arrow" src="/global/chevron_right.svg" />}
          </React.Fragment>
        );
      })}
    </SubHeading>
  );
}
